import { render, staticRenderFns } from "./industry-trends-SocialMngSolutions.vue?vue&type=template&id=625f0fa9&scoped=true"
import script from "./industry-trends-SocialMngSolutions.vue?vue&type=script&lang=js"
export * from "./industry-trends-SocialMngSolutions.vue?vue&type=script&lang=js"
import style0 from "./industry-trends-SocialMngSolutions.vue?vue&type=style&index=0&id=625f0fa9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625f0fa9",
  null
  
)

export default component.exports